// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
var _excluded = ["product_tmpl", "source"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment } from 'react';
import { use_agree } from './use_agree';
import { Download_link } from './download_link.js';
import { Hola_tabs } from '../ui/hola_tabs.js';
import Icon_pl_browsers from '../img/svg/pl/ic-apps-browsers.svg';
import Icon_pl_mobile from '../img/svg/pl/ic-apps-mobile.svg';
import Icon_pl_desktop from '../img/svg/pl/ic-apps-desktop.svg';
import Icon_pl_tv from '../img/svg/pl/ic-apps-tv.svg';
import Icon_pl_other from '../img/svg/pl/ic-apps-other.svg';
import Icon_pl_more from '../img/svg/pl/ic-apps-more.svg';
import Icon_pl_browsers_active from '../img/svg/pl/ic-apps-browsers-active.svg';
import Icon_pl_mobile_active from '../img/svg/pl/ic-apps-mobile-active.svg';
import Icon_pl_desktop_active from '../img/svg/pl/ic-apps-desktop-active.svg';
import Icon_pl_tv_active from '../img/svg/pl/ic-apps-tv-active.svg';
import Icon_pl_other_active from '../img/svg/pl/ic-apps-other-active.svg';
import Icon_pl_more_active from '../img/svg/pl/ic-apps-more-active.svg';
import Icon_pl_chrome from '../img/svg/pl/ic-chrome-active.svg';
import Icon_pl_edge from '../img/svg/pl/ic-edge-active.svg';
import Icon_pl_opera from '../img/svg/pl/ic-opera-active.svg';
import Icon_pl_android from '../img/platforms/ic_android.svg';
import Icon_pl_ios from '../img/svg/pl/ic-ios-active.svg';
import Icon_pl_huawei from '../img/svg/pl/ic-huawei-active.svg';
// import Icon_pl_samsung from '../img/svg/pl/ic-samsung-active.svg';
import Icon_pl_windows from '../img/svg/pl/ic-windows-active.svg';
import Icon_pl_mac_beta from '../img/svg/pl/ic-mac-active.svg';
import Icon_pl_firetv from '../img/svg/pl/ic-firetv-active.svg';
import Icon_pl_lg from '../img/svg/pl/ic-lg-active.svg';
import Icon_pl_appletv from '../img/svg/pl/ic-appletv-active.svg';
import Icon_pl_smarttv from '../img/svg/pl/ic-smarttv-active.svg';
import Icon_pl_xbox from '../img/svg/pl/ic-xbox-active.svg';
import Icon_pl_playstation from '../img/svg/pl/ic-playstation-active.svg';
import Icon_pl_router from '../img/svg/pl/ic-router-active.svg';
var default_cats = {
  browsers: 'Browser Apps',
  mobile: 'Mobile Apps',
  desktop: 'Desktop Apps',
  tv: 'TV Apps',
  other: 'Other Hola Apps',
  more: 'More from Hola'
};
var cat_icons = {
  'ic-apps-browsers': /*#__PURE__*/React.createElement(Icon_pl_browsers, {
    width: 48,
    height: 48
  }),
  'ic-apps-mobile': /*#__PURE__*/React.createElement(Icon_pl_mobile, {
    width: 48,
    height: 48
  }),
  'ic-apps-desktop': /*#__PURE__*/React.createElement(Icon_pl_desktop, {
    width: 48,
    height: 48
  }),
  'ic-apps-tv': /*#__PURE__*/React.createElement(Icon_pl_tv, {
    width: 48,
    height: 48
  }),
  'ic-apps-other': /*#__PURE__*/React.createElement(Icon_pl_other, {
    width: 48,
    height: 48
  }),
  'ic-apps-more': /*#__PURE__*/React.createElement(Icon_pl_more, {
    width: 48,
    height: 48
  }),
  'ic-apps-browsers-active': /*#__PURE__*/React.createElement(Icon_pl_browsers_active, {
    width: 48,
    height: 48
  }),
  'ic-apps-mobile-active': /*#__PURE__*/React.createElement(Icon_pl_mobile_active, {
    width: 48,
    height: 48
  }),
  'ic-apps-desktop-active': /*#__PURE__*/React.createElement(Icon_pl_desktop_active, {
    width: 48,
    height: 48
  }),
  'ic-apps-tv-active': /*#__PURE__*/React.createElement(Icon_pl_tv_active, {
    width: 48,
    height: 48
  }),
  'ic-apps-other-active': /*#__PURE__*/React.createElement(Icon_pl_other_active, {
    width: 48,
    height: 48
  }),
  'ic-apps-more-active': /*#__PURE__*/React.createElement(Icon_pl_more_active, {
    width: 48,
    height: 48
  })
};
var app_ic_size = {
  width: 32,
  height: 32
};
var app_icons = {
  chrome: /*#__PURE__*/React.createElement(Icon_pl_chrome, app_ic_size),
  edge: /*#__PURE__*/React.createElement(Icon_pl_edge, app_ic_size),
  opera: /*#__PURE__*/React.createElement(Icon_pl_opera, app_ic_size),
  android: /*#__PURE__*/React.createElement(Icon_pl_android, app_ic_size),
  ios: /*#__PURE__*/React.createElement(Icon_pl_ios, app_ic_size),
  huawei: /*#__PURE__*/React.createElement(Icon_pl_huawei, app_ic_size),
  // XXX dmitriikup: URG request from noav to remove all Samsung
  // mentions from www
  // samsung: <Icon_pl_samsung {...app_ic_size}/>,
  windows: /*#__PURE__*/React.createElement(Icon_pl_windows, app_ic_size),
  mac_beta: /*#__PURE__*/React.createElement(Icon_pl_mac_beta, app_ic_size),
  firetv: /*#__PURE__*/React.createElement(Icon_pl_firetv, app_ic_size),
  lg: /*#__PURE__*/React.createElement(Icon_pl_lg, app_ic_size),
  appletv: /*#__PURE__*/React.createElement(Icon_pl_appletv, app_ic_size),
  smarttv: /*#__PURE__*/React.createElement(Icon_pl_smarttv, app_ic_size),
  xbox: /*#__PURE__*/React.createElement(Icon_pl_xbox, app_ic_size),
  playstation: /*#__PURE__*/React.createElement(Icon_pl_playstation, app_ic_size),
  router: /*#__PURE__*/React.createElement(Icon_pl_router, app_ic_size)
};
var Products_slider = _ref => {
  var _ref$product_tmpl = _ref.product_tmpl,
    product_tmpl = _ref$product_tmpl === void 0 ? undefined : _ref$product_tmpl,
    source = _ref.source,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _use_agree = use_agree({
      just_question: true
    }),
    a_props = _use_agree.a_props,
    Agree_window = _use_agree.Agree_window,
    on_click = _use_agree.on_click;
  var Tmpl = product_tmpl || Download_link;
  var c2name = _objectSpread({}, default_cats);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Hola_tabs, _extends({}, rest, {
    on_click: on_click,
    c2name: c2name,
    c_icons: cat_icons,
    icons_type: "pl",
    tmpl: props => /*#__PURE__*/React.createElement(Tmpl, _extends({}, props, {
      source: source,
      icons: app_icons
    }))
  })), /*#__PURE__*/React.createElement(Agree_window, a_props));
};
export { Products_slider, Hola_tabs };